import axios from 'axios';

import { IAdvertisementSupporterStatus } from '@/shared/model/advertisement-supporter-status.model';

const baseApiUrl = 'api/advertisement-supporter-statuses';

export default class AdvertisementSupporterStatusService {
  public find(id: number): Promise<IAdvertisementSupporterStatus> {
    return new Promise<IAdvertisementSupporterStatus>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAdvertisementSupporterStatus): Promise<IAdvertisementSupporterStatus> {
    return new Promise<IAdvertisementSupporterStatus>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAdvertisementSupporterStatus): Promise<IAdvertisementSupporterStatus> {
    return new Promise<IAdvertisementSupporterStatus>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
